import PRForm from "../../../components/personal_record/PRForm";
import { useParams } from "react-router-dom";
import { useFetchAthleteQuery } from "../../../store";
import PRTable from "../../../components/personal_record/PRTable";
import PRChart from "../../../components/personal_record/PRChart";
import FormModal from "../../../components/modals/FormModal";
import { useState } from "react";

export default function PRManager(){
  let table;
  let { id } = useParams();
  const { data, error, isLoading} = useFetchAthleteQuery(id);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let athlete;
  let content;
  if (isLoading) {
    content = <div> Loading...</div>;
    return content;
  }
  if (error) {
    content = <div> Error: {error.message}</div>;
    return content;
  }
  else{
    athlete = data[0];
    content = <div className="space-y-12">
      <div className="max-w-5xl self-center border-b border-gray-900/10 pb-12">
        <PRChart athlete={athlete} />
      </div>
      <div className="border-b border-gray-900/10 pb-12">
        <button type="button"
          className='bg-indigo-600 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mx-1 inline-flex items-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm'
          onClick={() => setIsModalOpen(true)}
        >
          Add PR
        </button>
        <PRTable athlete={athlete} />
      </div>
      <div className="pb-12">
        <FormModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Add PR Record"
          maxWidth="max-w-3xl"
          closeButtonText="Cancel"
          showCloseButton={false}
          size="xl"
        >
          <PRForm athlete={athlete} />
        </FormModal>
      </div>
    </div>
  }
  return (
    content
  )
}